class RadioSetting {
  constructor() {
    this.radioLists = document.querySelectorAll('.js-radio-list');
    this.init();
  }

  init() {
    console.log('RadioSetting init');
    if (!this.radioLists) return;

    console.log('RadioSetting init2');
    this.radioLists.forEach((radioList, index) => {
      const radioButtons = radioList.querySelectorAll('.m-radio-input');
      radioButtons.forEach((radioButton, index2) => {
        radioButton.setAttribute('name', `radio-${index}`); // ラジオボタンにユニークなname属性を付与
        radioButton.setAttribute('id', `radio-${index}-${index2}`); // ラジオボタンにユニークなid属性を付与
      });

      const radioLabels = radioList.querySelectorAll('.m-radio');
      radioLabels.forEach((radioLabel, index2) => {
        radioLabel.setAttribute('for', `radio-${index}-${index2}`); // ラベルに対応するfor属性を付与
      });

    });
  }

}

export default RadioSetting;
